// Quién responde. La primera frase de cualquier texto legal, y la que no se deduce del código.
//
// LO QUE FALTA ESTA VACIO A PROPOSITO, no con un ejemplo dentro. Un NIF de muestra en un
// aviso legal es peor que un hueco: parece rellenado. Mientras alguno de los campos
// obligatorios siga vacío, `tools/check_legal.py` impide que los textos se enlacen desde el
// pie de la web — están escritos, pero no publicados.
export const RESPONSABLE = {
  nombre: "Gabriel Molina Martín",
  nif: "54561687Y",                       

  // EL DOMICILIO ESTA VACIO Y HACE FALTA. Hasta el 15 de septiembre de 2026 esto decia que
  // podia estar vacio «mientras no se cobre», y esa condicion ya no se cumple: se cobra desde
  // el 5 de septiembre. O sea que esto dejo de ser una decision y paso a ser una deuda, y lo
  // que hay debajo no es una excusa: es una deuda con fecha de vencimiento.
  //
  // SON DOS OBLIGACIONES DISTINTAS Y SE CONFUNDEN. El RGPD pide «identidad y datos de
  // contacto» del responsable: nombre, NIF y un correo lo cumplen, y eso esta cubierto. La que
  // pide domicilio es la LSSI-CE (art. 10), y se aplica a quien presta servicios CON ACTIVIDAD
  // ECONOMICA. Eso es lo que falta.
  //
  // Y NO TIENE POR QUE SER LA VIVIENDA DE NADIE, que es el motivo de que siga vacio: una
  // domiciliacion o una oficina virtual sirven, cuestan veinte o treinta euros al mes y se
  // contratan en una tarde sin gestor. Publicar la direccion de tu casa en una web que leen tus
  // propios alumnos y sus familias es una decision que no se toma por descuido.
  //
  // DOS COSAS QUE SE HAN DESCARTADO, escritas para que no se vuelvan a proponer:
  //   · **Una direccion provisional o una ciudad a secas.** Un dato falso en el unico documento
  //     cuyo trabajo es decir quien responde es peor que el hueco, y a «Badalona» no se le
  //     notifica nada. El hueco al menos se ve; un dato inventado parece rellenado.
  //   · **La direccion del centro donde se trabaja.** Es de la fundacion, no de aqui. Pondria a
  //     una empresa privada bajo la direccion de su empleador en un texto legal que ese
  //     empleador no ha visto ni autorizado.
  domicilio: "",
  // Por qué no lo hay. Obligatorio mientras `domicilio` esté vacío: `tools/check_legal.py` no
  // deja publicar sin una cosa o la otra. Un hueco callado parece un olvido; esto es una
  // decisión con fecha de caducidad.
  // CUANDO SE COMPROBO POR ULTIMA VEZ QUE ESA RAZON SEGUIA SIENDO CIERTA, en aaaa-mm-dd.
  // Existe porque la de arriba estuvo seis dias siendo falsa sin que nadie lo viera: decia
  // que la Academia no cobra, y cobra desde el 5 de septiembre de 2026. `check_legal.py`
  // comprobaba que HUBIERA una razon, no que fuera verdad. Ahora caduca a los noventa dias.
  sin_domicilio_revisado: "2026-09-15",

  sin_domicilio_porque:
    "Academia Alpha se presta en línea y sin local abierto al público, y el domicilio de "
    + "notificaciones está pendiente de contratar: será una domiciliación, no una vivienda "
    + "particular ni la dirección de un tercero. Mientras tanto, el responsable queda "
    + "identificado por su nombre y su NIF, y atiende cualquier comunicación en el correo que "
    + "figura más abajo. Revisado el 15 de septiembre de 2026.",
  email: "gabriel@academialpha.com",
  web: "academialpha.com",
  // Si algún día hay DPD designado, aquí. Hoy no lo hay y no es obligatorio en este caso,
  // pero conviene revisarlo cuando entren centros educativos como clientes.
  dpd: "",
};

// Los campos sin los que un aviso legal no es un aviso legal. El domicilio NO está: puede
// faltar mientras no haya actividad económica, y en ese caso tiene que estar dicho por qué.
export const OBLIGATORIOS = ["nombre", "nif", "email"];

const puesto = (c) => String(RESPONSABLE[c] || "").trim();

export function faltan() {
  const sin = OBLIGATORIOS.filter((c) => !puesto(c));
  // Sin domicilio Y sin explicación, sí falta: lo que no puede haber es un hueco callado.
  if (!puesto("domicilio") && !puesto("sin_domicilio_porque")) sin.push("domicilio");
  return sin;
}

/** ¿Se pueden publicar ya los textos? */
export function completo() {
  return faltan().length === 0;
}

/** El responsable como se escribe dentro de un texto legal. */
export function comoSeFirma() {
  const partes = [RESPONSABLE.nombre];
  if (RESPONSABLE.nif) partes.push(`NIF ${RESPONSABLE.nif}`);
  if (puesto("domicilio")) partes.push(RESPONSABLE.domicilio);
  partes.push(RESPONSABLE.email);
  return partes.join(" · ");
}

/**
 * La frase de identificación, con domicilio o sin él.
 *
 * Existe para que los textos no tengan que saber si hay dirección o no. Sin ella, la política
 * y las condiciones dirían «con domicilio en » seguido de nada, que es peor que no decirlo:
 * un texto legal a medio construir se lee como descuido y resta la credibilidad de todo lo
 * demás, que sí está bien hecho.
 */
/**
 * La identificación CORTA, para el aviso de la primera capa.
 *
 * POR QUE HAY DOS. El artículo 13 del RGPD pide «identidad y datos de contacto del
 * responsable», y eso son un nombre y un correo. **El NIF no lo pide**, ni el RGPD ni nadie
 * para esta capa: el NIF y la fórmula del establecimiento son de la **LSSI-CE (art. 10)**, que
 * gobierna el aviso legal de la web, no el cartel que se lee antes de escribir un correo. Están
 * donde tienen que estar —en el aviso legal y en la política— y de ahí no se mueven.
 *
 * Y AQUÍ SOBRABAN POR DOS MOTIVOS. Uno de forma: quien lee esto tiene catorce años y está a
 * punto de dar su correo; un NIF y un «ejerce sin establecimiento abierto al público» no le
 * dicen nada, y lo que no informa solo ocupa el sitio de lo que sí. Y otro de fondo: es el NIF
 * de una persona, publicado en la pantalla que más miran sus propios alumnos. Cuanto menos
 * viaje, mejor.
 */
export function identificacionCorta() {
  return `${RESPONSABLE.nombre} (${RESPONSABLE.email})`;
}

export function identificacion() {
  const base = `${RESPONSABLE.nombre}, con NIF ${RESPONSABLE.nif}`;
  return puesto("domicilio")
    ? `${base} y domicilio en ${RESPONSABLE.domicilio}`
    : `${base}, que ejerce sin establecimiento abierto al público`;
}
